import {Teklif} from './teklif';

export class TekliflerPage {

  currentPage: number;
  pageCount: number;
  pageSize: number;
  rowCount: number;
  firstRowOnPage: number;
  lastRowOnPage: number;
  private pResults: Teklif[];


  constructor(obj?: any) {
    if (obj == null) {
      return;
    }
    Object.assign(this, obj);
  }

  public get results(): Teklif[] {
    return this.pResults;
  }

  public set results(list: Teklif[]) {
    if (list != null) {
      this.pResults = list.map(t => new Teklif(t));
    }
  }

}
